/* lua.js generated code 0.3.0 */

require("clover/scene/BaseScene")
var LevelLoadingScene = xClass("LevelLoadingScene", BaseScene)
// 友谊赛 otherData.isFriendPvp = true
LevelLoadingScene.create = function (resourceList, finishCallback, levelId, otherData = {}) {
    var s = LevelLoadingScene.new()
    // if (otherData.isFriendPvp){
    //     s.isFriendPvp = otherData.isFriendPvp;
    // }else{
        s.isFriendPvp = false;
    // }
    s.setName("LevelLoadingScene")
    s.initResourceList(resourceList, finishCallback, levelId)
    s.initScene()
    console.log("levelloading LevelLoadingScene")
    
    return s
}
LevelLoadingScene.prototype.run = function () {
    var self = this
    let director = cc.Director.getInstance()
    let curScene = director.getRunningScene()
    // 兼容快速开始下一关
    if (curScene){
        console.log("@@@@current scene name1:"+curScene.name )
    }
    if (!curScene || curScene.name === 'HomeScene') {
        director.pushScene(self)
    } else {
        director.replaceScene(self)
    }
}
LevelLoadingScene.prototype.initResourceList = function (resourceList, finishCallback, levelId) {
    var self = this
    // body
    self.resourceList = resourceList
    self.finishCallback = finishCallback
    self.levelId = levelId
}
var [ProgressWidth, ProgressHeight] = [155, 11]
var config_pos = table(
    [0, table([1, "y1", 0], [1, "y2", 28])],
    [0, table([1, "y1", 0], [1, "y2", 40])],
    [0, table([1, "y1", 0], [1, "y2", -5])]
)
var special_load_png = table([1, GamePlayType.kFish, table([0, table(
    [1, "pngName", "loading_hammer"],
    [1, "posy1", 0],
    [1, "posy2", -40]
)], [0, table(
    [1, "pngName", "loading_surffing"],
    [1, "posx1", -60],
    [1, "posy1", 0],
    [1, "posy2", 28]
)])], [1, GamePlayType.kBlockCollection, table([0, table(
    [1, "pngName", "loading_bombear"],
    [1, "posy1", 0],
    [1, "posy2", -28]
)])])
var Max_Loading_Count = 4
LevelLoadingScene.prototype.onInit = function () {
    var self = this
    // body
    var container = cc.Node.create()
    var scaleValue = display.height / GamePlayConfig_Design_Height
    if (scaleValue > 1) {
        scaleValue = 1
    }
    container.setScale(scaleValue)
    container.setPosition(display.center)
    self.addChild(container)
    self.container = container

    var levelDigst = LevelConfigManager.getInstance().getLevelDigest(self.levelId)
    levelDigst.loading_id = levelDigst.loading_id || (self.levelId % 9 + 1)
    var csbName = "flash/scenes/level_loading/loading_new_loading_panel_0"+levelDigst.loading_id+".csb"
    if (self.isFriendPvp){
        csbName = "cocos/loading_new_loading_panel_pvp.csb"
    }
    var illustration = cc.CSLoader.createNode(csbName);
    container.addChild(illustration)

    var loading = cc.LabelTTF.create("载入中", null, 40)
    loading.setColor(cc.color(208, 246, 255))
    container.addChild(loading)
    loading.setPosition(-40, (-display.height / 2  + 150 + _safe_area_bottom) * ( GamePlayConfig_Design_Height / display.height ))

    for (let i = 1; i <= 3; i++){
        let dot = cc.LabelTTF.create(".", null, 40) 
        dot.setScale(1.2)
        dot.setColor(cc.color(208, 246, 255))
        container.addChild(dot)
        dot.setPosition(i * 20 + 10, loading.y)
        dot.runAction(
            cc.Sequence.create(
                cc.DelayTime.create( (i - 1) * 0.2),
                cc.CallFunc.create(function(){
                    dot.runAction(cc.RepeatForever.create(cc.Sequence.create(
                        
                        cc.MoveBy.create(0.2, cc.p(0, 10)),
                        cc.MoveBy.create(0.2, cc.p(0, -10)),
                        cc.DelayTime.create(1)
                    )))
                })
                
            )
        )
    }

    self.gameLoadingTimerId = setTimeout(() => {
        self.restartLevel()
    }, 15 * 1000);
        
}
// LevelLoadingScene.prototype.levelCrashHttp = function (cb) {
//     var self = this

//     if (self.alreadyCall) return
//     self.alreadyCall = true

//     function success(evt) {
//         // if (evt && evt.data) {
//             cb()
//         // }
        
//     }
//     let http = LevelCrashHttp.new()
//     http.addEventListener(Events.kComplete, success)
//     http.addEventListener(Events.kError, (evt) => {
//         console.log("levelCrashHttp error evt", evt)
//         // Toast.make(getText("error.tip."+ evt.data ))
//         cb()
//     })
//     http.addEventListener(Events.kCancel, (evt) => {
//         console.log("levelCrashHttp cancel evt", evt)
//         // Toast.make(getText("error.tip."+ evt.data ))
//         cb()
//     })
//     http.load(self.levelId, Localhost.time())
// }
LevelLoadingScene.prototype.restartLevel = function () {
    var self = this
    // body
    function createlabel(){
        
        let reloadlabel = cc.LabelBMFont.create("载入时间过长？", "font/zzgftongxin_40.fnt")   
        reloadlabel.setColor(cc.color(208, 246, 255)) 
        reloadlabel.setPosition(20, (-display.height / 2  + 200 + _safe_area_bottom) * ( GamePlayConfig_Design_Height / display.height ) + 80)
        self.container.addChild(reloadlabel)

       
        
        let reloadbtn =  UIButton.create(ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_btn_green_normal.png", cc.rect(95, 50, 10, 10)), true)
        // reloadbtn.setScaleX(1.2)
        // reloadbtn.setScaleY(0.5)
        reloadbtn.setContentSize(250, 100)
        reloadbtn.setPosition(0, (-display.height / 2  + 200 + _safe_area_bottom) * ( GamePlayConfig_Design_Height / display.height ))
        reloadbtn.on(UIButtonEvent.Click, function () {
            window.logCenter && logCenter.error(new Error(`user click restart btn ` + self.levelId), 'RestartLevelDirectly')
            window.mini.clearStorageSync()
            window.wxDownloader && wxDownloader.cleanAllAssets();
            window.mini.restartMiniProgram()
        })
        let reloadlabel1 = cc.LabelBMFont.create("重新加载", "font/zzgftongxin_40_greenstroke.fnt")   
        // reloadlabel.setColor(cc.color(208, 246, 255)) 
        reloadlabel1.setPosition(125, 50)
        reloadbtn.addChild(reloadlabel1)
        
        self.container.addChild(reloadbtn)
    }

    if (window.mini && window.mini.supportRestartLevel()){
        //调过startlevel
        if (_G.lastStartLevelHttpInfo && ( LevelType.getLevelTypeByLevelId(self.levelId) == GameLevelType.kMainLevel || LevelType.getLevelTypeByLevelId(self.levelId) == GameLevelType.kMysteryIsland || LevelType.isBuildShipLevel(self.levelId))) {
            self.allReplay = table()
            var replay = table()
            replay.level = self.levelId
            replay.topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
            // if (type(self.config) === "table" && type(self.config.realLevelIdFromABTest) === "number") {
            //     if (LevelType.getLevelTypeByLevelId(self.config.realLevelIdFromABTest) === GameLevelType.kABTest || LevelType.getLevelTypeByLevelId(self.config.realLevelIdFromABTest) === GameLevelType.kWeekly) {
            //         replay.realLevel = self.config.realLevelIdFromABTest
            //         replay.realLevelMD5 = he.ResManager.getInstance().getFileMd5("meta/level/" + tostring(replay.realLevel) + ".inf")
            //     }
            // }
            replay.randomSeed = 0
            replay.replaySteps = table()
            replay.dropAdjustData = table.serialize(DATargetCounter.getInstance().encode().expectCountList)
            replay.dropAdjustDataV2 = table.serialize(DATargetCounterV2.getInstance().encode().expectCountList)
            replay.dropAdjustScheme = table.serialize(DAManager.getInstance().encodeScheme().currentSchemeCfg)
            replay.dropAdjustCube = DAManager.getInstance().getCube()
            replay.passiveRefreshCount = 0
            replay.isOver = false
            replay.selectedItemsData = table()
            // GameReviveType = {"kStep":GamePropIds.kAdd5}
            // ameReviveTypeToGoodsIdRef = {[GamePropIds.kAdd5]: [26, 1002, 1003, 1004, 1005]}
            replay.reviveRef = {[GamePropIds.kAdd5]: [26, 1002, 1003, 1004, 1005]}
            // 录像里加上是否用新的关末加步数
            replay.newLevelEnd = UserManager.getInstance().getInNewLevelEnd();

            // replay.preActivityPropsData = table()
            // replay.md5 = he.ResManager.getInstance().getCurVersion()
            replay.lvmd5 = ResManager.getLevelMd5(self.levelId)
            // replay.userTopLevel = self.userTopLevel
            // replay.needAttachAnimalCoinNum = self.needAttachAnimalCoinNum
            // replay.fragmentId = self.getFragmentId()
            // replay.difficultyChangeStrategy = self.difficultyChangeStrategy
            // replay.changeDifficultySuccess = self.changeDifficultySuccess
            // replay.scoreAnimalBuffLevel = self.scoreAnimalBuffLevel
            // replay.goldPackageNum = self.goldPackageNum || 0
            // replay.lastGameInfo = self.lastGameInfo
            // replay.isGoldRecovery = self.PlayUIDelegate.isGoldRecovery
            replay.payNum = UserTagData.getInstance().userLabelData.payNum || 0; // 录像内记录付费
            replay.completeExpect = UserTagData.getInstance().userLabelData.completeExpect || 0; // 录像内记录期望
            replay.pdiff = UserTagData.getInstance().userLabelData.pDiff || 0; // 录像内记录个人难度
            replay.ndiff = UserTagData.getInstance().userLabelData.nDiff || 0; // 录像内记录自然难度

            // if (self.isFriendPvp){ //友谊赛过滤掉
                // replay.roomId = self.PlayUIDelegate.pvpManager.id;
                // replay.leftTime = self.PlayUIDelegate.pvpLogic.leftTime;
                // replay.you = self.PlayUIDelegate.pvpManager.you;
                // replay.me = self.PlayUIDelegate.pvpManager.me;
            // }

            if (_G.__use_small_res) {
                replay.mini = 1
            }
            if (_G.lastStartLevelHttpInfo.mysteryIsland){
                replay.mysteryIsland = $tableToObj(_G.lastStartLevelHttpInfo.mysteryIsland)
            }
            if (_G.lastStartLevelHttpInfo.actPreProp){
                replay.actPreProp = $tableToObj(_G.lastStartLevelHttpInfo.actPreProp)
            }
            // 记录主线收集活动的活动类型
            if ( _G.lastStartLevelHttpInfo.levelCollectType){
                replay.levelCollectType = _G.lastStartLevelHttpInfo.levelCollectType
            }
            //
            if ( _G.lastStartLevelHttpInfo.props){
                for (let propID of  _G.lastStartLevelHttpInfo.props){
                    if ($null(propID)) continue
                    table.insert(replay.selectedItemsData, propID)
                }
                
            }
            if (_G.lastStartLevelHttpInfo.extraData){
                replay.extraData = _G.lastStartLevelHttpInfo.extraData
            }

            if (_G.lastStartLevelHttpInfo.buildshipAlreadyStartlevel){
                replay.buildshipAlreadyStartlevel = _G.lastStartLevelHttpInfo.buildshipAlreadyStartlevel
            }

            replay.levelGroup = UserManager.getInstance().getLevelGroup()
            
            // self.mystertyPetData = self.mysteryLogic.dump()
            // if (self.mysteryLogic)replay.mystertyPetData = self.mysteryLogic.dump()
            replay.md5 = ResManager.getLevelMd5(replay.level)
            table.insert(self.allReplay, replay)
            self.replay = replay
            // if ($len(self.allReplay) > GamePlayConifg_Replay_Saved_Max) {
            //     table.remove(self.allReplay, 1)
            // }
            var batchReplay = {
                replay: table.serialize2(self.allReplay),
                uid: UserManager.getInstance().uid,
                // createTime: self.createTime
            }

           
        
            
            writeStartLevelReplayHttp(JSON.stringify( batchReplay), function() {
                //    Toast.make("已存后端")
                    console.log("startlevelreplay 已存后端", JSON.stringify(batchReplay))
                    
                    createlabel()
                    
            })
            // let http = WriteStartLevelReplayHttp.new()
            // http.addEventListener(Events.kComplete, success)
            // http.addEventListener(Events.kError, (evt) => {
            //     Toast.make(curryQuickGetErrorText(evt.data))
            //     // reject(evt)
            // })
            // http.addEventListener(Events.kCancel, () => {
            //     // reject(0)
            // })
            // http.load(JSON.stringify(batchReplay))
            // window.logCenter && logCenter.error(new Error(`send replay data ` + self.levelId), 'RestartLevelDirectly')
            
        }else{
            console.log("startlevelreplay 不存直接重启")
            createlabel()
        }
    }
    // ReplayManager.getInstance().writeReplay()
}
LevelLoadingScene.prototype.getScript = function () {
    if (!window.mqq &&window.mini && mini.supportSubpackage()) {
        return new Promise((resolve, reject) => {
            mini.loadSubpackage({
                name: 'game',
                success: res => {
                    cc.log('load subpack success', res)
                    resolve(res)
                },
                fail: res => {
                    cc.warn('load subpack fail', res)
                    reject(res)
                }
            })
        })
    } else {
        return require.ensure([], () => {
            require.context('../gamePlay', true, /^((?!mode\/WeeklyMode).)*$/)
            require.context('../itemView')
            require.context('../levelTarget')
            require.context('../animation', false, /^Tile.+\.js$/)
            require.context('../animation/boss')
            require.context('../animation/background')
            require.context('../gameGuide/childAni')
        }, null, 'game')
    }

}

LevelLoadingScene.prototype.onEnter = function () {
    var self = this
    BaseScene.prototype.onEnter.call(self)
    if (window.mini){
        SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(false, true, true)
    }

    // // 卸掉宝箱，岛屿
    // var releaseRes = []
    // HomeStarChestRes.forEach(e => {
    //     if(e){
    //         releaseRes.push(e);
    //     }
    // });
    // let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager");
    // let topIslandId = UserManager.getInstance().getCurrentIslandsIdByLevel();
    // let topIslandConfig = UserManager.getInstance().getIslandConfigById(topIslandId);
    // let islandRes = IslandsManager.getInstance().getIslandRes(topIslandConfig);
    // islandRes.resList.forEach(e => {
    //     releaseRes.push(e);
    // });
    // cc.log("releaseRes", releaseRes);
    // ResManager.release(releaseRes);

    // GlobalEventDispatcher.getInstance().addEventListener(
    //     kGlobalEvents.kGameResLoadProgress, 
    //     function(event) {
    //         self.updateProgress(event.data.progress)
    //     }
    // )
    return

    var resourceList = self.resourceList
    if (!resourceList) {
        if (self.finishCallback) {
            self.finishCallback()
        }
        return
    }
    var loader = FrameLoader.new()
    var plistLen = $len(resourceList.kPlist)
    for (var i = 1, v = resourceList.kPlist[1]; i <= plistLen; i++ , v = resourceList.kPlist[i]) {
        if (v != null){
            loader.add(v)
        }
    }
    for (var i = 1, v = resourceList.kMusics[1]; v; i++ , v = resourceList.kMusics[i]) {
        //TODO:test only
        loader.add(v, kFrameLoaderType.sfx)
    }
    if (resourceList.kPrefillPool && resourceList.kPrefillPool[1])
    {
        for (let i = 1, v = resourceList.kPrefillPool[1]; v; i++, v = resourceList.kPrefillPool[i]) {
            loader.add(v, kFrameLoaderType.csb)
        }
    }

    //loader.add("flash/test_big.png")
    loader.add(this.getScript)
    console.log("start level load");
    function onFrameLoadComplete() {
        loader.removeAllEventListeners()
        if (self.finishCallback) {
            // step.120 新用户第一关加载完毕
            if (_G.kIsNewUser && !_G.firstLevelLoadComplete) {
                _G.firstLevelLoadComplete = true;
                dc4UserLoad(115);
            }
            DCAssist.dc4LevelUserOp120(self.levelId)
            self.finishCallback()
        }
    }
    function onFrameLoadProgress() {
        var progress = loader.loaded / loader.getLength()
        self.updateProgress(progress)
    }
    function onFrameLoadError(evt) {
        var err = "level_loading_scene onFrameLoadError:" + JSON.stringify(evt.data) + ",loadList:" + JSON.stringify(loader.list);
        if (window.logCenter){
            window.logCenter.error(new Error(err), "LevelLoadingScene");
        }else{
            cc.error("onFrameLoadError:" + err);
        }
        
        require("clover/sns/SnsProxy").getInstance().showDialog({
            text : "资源加载失败，请重试",
            needOkBtn : true,
            okBtnText : "重试",
        }, () => {
            loader.retry()
        })
    }
    loader.addEventListener(Events.kComplete, onFrameLoadComplete)
    loader.addEventListener(Events.kProgress, onFrameLoadProgress)
    loader.addEventListener(Events.kError, onFrameLoadError)
    loader.load()
}
LevelLoadingScene.prototype.onKeyBackClicked = function () {
    // cc.Director:getInstance():popScene()
}
LevelLoadingScene.prototype.updateProgress = function (progress) {
    var self = this
    // body
    var width = Math.max(ProgressWidth * progress, 11)
    self.progress.setPreferredSize(cc.size(width, ProgressHeight))
}
LevelLoadingScene.prototype.cleanup = function () {
    var self = this;
    BaseScene.prototype.cleanup.call(this);
    if (self.gameLoadingTimerId) {
        clearTimeout(self.gameLoadingTimerId)
        self.gameLoadingTimerId = null
    } 

    _G.lastStartLevelHttpInfo = null
}
module.exports = LevelLoadingScene
